type FileDownloadOptions = {
	blob: Blob
	defaultFilename: string
}

/**
 * Downloads a file from a Blob. Automatically detects content type
 * and sets the appropriate file extension (csv or zip).
 */
export function downloadFile({
	blob,
	defaultFilename,
}: FileDownloadOptions): void {
	const url = window.URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url

	const isZip =
		blob.type === 'application/zip' ||
		blob.type === 'application/x-zip-compressed'
	const extension = isZip ? 'zip' : 'csv'
	const filename = `${defaultFilename}.${extension}`

	link.download = filename

	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)

	window.URL.revokeObjectURL(url)
}
